import { FormEvent, useState, forwardRef, useImperativeHandle, useEffect } from 'react'
import { t } from 'i18next'

import Breadcrumb from 'src/components/shared/Breadcrumb/Breadcrumb'
import { Interviniente } from 'src/interfaces/EscritosLegales'
import { Escrito } from '../../../Tramite/TramiteFormViewStyles'
import IntervinienteView from '../Intervinientes/components/Interviniente/IntervinienteView'
import SubmitButtons from '../Submit/SubmitButtons'

type WrapperFormPropsType = {
  section: string
  handleSubmit: (e?: FormEvent<HTMLFormElement> | undefined) => void
  onCleanForm?: () => void
  info?: JSX.Element
  children: JSX.Element
}

export type WrapperFormRefType = {
  newInterviniente: (data: Interviniente | null) => void
  editInterviniente: (data: Interviniente) => void
  close: () => void
}

export default forwardRef<WrapperFormRefType, WrapperFormPropsType>(function(
  { section, info = null, children, handleSubmit, onCleanForm = () => {} },
  ref
): JSX.Element {
  const [interviniente, setInterviniente] = useState<boolean>(false)
  const [dataIterviniente, setDataInterviniente] = useState<Interviniente | null>(null)

  useImperativeHandle(
    ref,
    () => {
      return {
        newInterviniente: data => {
          setDataInterviniente(data)
          setInterviniente(true)
        },

        editInterviniente: data => {
          setDataInterviniente(data)
          setInterviniente(true)
        },

        close: () => {
          setInterviniente(false)
        }
      }
    },
    []
  )

  function scrollToTop() {
    document.getElementsByTagName('main')[0].scrollTo(0, 0)
  }

  useEffect(() => {
    scrollToTop()
  }, [interviniente])

  return (
    <>
      <div style={{ display: interviniente ? 'none' : 'block' }}>
        <form onSubmit={handleSubmit}>
          <Breadcrumb section={section}>
            <SubmitButtons disabled={interviniente} onCleanForm={onCleanForm} />
          </Breadcrumb>
          {info}
          <Escrito>{children}</Escrito>
        </form>
      </div>
      {interviniente && (
        <IntervinienteView
          title={t('form.dialog.title.nuevo_interviniente')}
          closeDialog={() => {
            setInterviniente(false)
          }}
          formValues={dataIterviniente}
        >
          <Breadcrumb section={section}>
            <SubmitButtons disabled />
          </Breadcrumb>
        </IntervinienteView>
      )}
    </>
  )
})
